<template>
  <div>
    <div class="input-area">
      <div
        v-show="isEntering"
        :style="{ top: messageImgs.length > 0 ? '-106px' : '-26px' }"
        class="entering"
      >
        客服正在输入...
      </div>
      <chat-emotion v-model="emotionVisible" @select="selectEmotion" />
      <div class="toolbar">
        <div class="wrapper">
          <i
            class="icon-emoji"
            @click="showEmotion"
            :class="{ active: emotionVisible }"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.9999 0.428558C6.72661 0.428558 4.54643 1.33164 2.93898 2.93914C1.33153 4.54663 0.428467 6.72687 0.428467 9.00021C0.428525 10.1259 0.65029 11.2405 1.0811 12.2804C1.51191 13.3203 2.14332 14.2652 2.9393 15.0612C3.73527 15.8571 4.68021 16.4884 5.72016 16.9191C6.76012 17.3498 7.87473 17.5715 9.00034 17.5714C10.126 17.5714 11.2405 17.3496 12.2805 16.9188C13.3204 16.4879 14.2652 15.8565 15.0611 15.0605C15.857 14.2645 16.4883 13.3196 16.919 12.2796C17.3497 11.2396 17.5714 10.125 17.5713 8.99932C17.5713 4.26616 13.7329 0.428558 8.9999 0.428558ZM8.9999 15.7852C8.10229 15.7955 7.21156 15.6276 6.37931 15.2912C5.54705 14.9548 4.78981 14.4567 4.15143 13.8256C3.51306 13.1944 3.00625 12.4429 2.66035 11.6146C2.31445 10.7862 2.13634 9.89745 2.13634 8.99976C2.13634 8.10208 2.31445 7.21331 2.66035 6.38495C3.00625 5.55658 3.51306 4.80508 4.15143 4.17397C4.78981 3.54286 5.54705 3.04469 6.37931 2.70831C7.21156 2.37193 8.10229 2.20402 8.9999 2.21432C9.8975 2.20402 10.7882 2.37193 11.6205 2.70831C12.4527 3.04469 13.21 3.54286 13.8484 4.17397C14.4867 4.80508 14.9935 5.55658 15.3394 6.38495C15.6853 7.21331 15.8634 8.10208 15.8634 8.99976C15.8634 9.89745 15.6853 10.7862 15.3394 11.6146C14.9935 12.4429 14.4867 13.1944 13.8484 13.8256C13.21 14.4567 12.4527 14.9548 11.6205 15.2912C10.7882 15.6276 9.8975 15.7955 8.9999 15.7852ZM6.76864 8.77699C7.50793 8.77699 8.10704 8.07786 8.10704 7.21445C8.10704 6.35103 7.50704 5.65191 6.76775 5.65191C6.02847 5.65191 5.42847 6.35103 5.42847 7.21445C5.42847 8.07786 6.02847 8.77699 6.76864 8.77699ZM11.232 8.77699C11.9722 8.77699 12.5713 8.07786 12.5713 7.21445C12.5713 6.35103 11.9713 5.65191 11.232 5.65191C10.4928 5.65191 9.89275 6.35193 9.89275 7.21445C9.89275 8.07697 10.4928 8.77699 11.232 8.77699ZM12.8758 10.1931C12.7182 10.1136 12.5357 10.099 12.3675 10.1524C12.1993 10.2058 12.0587 10.323 11.9758 10.4788C11.9454 10.5378 11.1999 11.9012 9.00079 11.9012C6.8124 11.9012 6.0624 10.5503 6.0249 10.4797C5.94462 10.3212 5.80465 10.201 5.63579 10.1457C5.46692 10.0903 5.28299 10.1043 5.12445 10.1846C4.96591 10.2649 4.84576 10.4049 4.79042 10.5737C4.73508 10.7426 4.74908 10.9265 4.82936 11.0851C4.874 11.1735 5.94365 13.2405 9.00079 13.2405C12.0588 13.2405 13.1267 11.1726 13.1704 11.0842C13.2491 10.9269 13.2623 10.7448 13.2071 10.5778C13.1518 10.4108 13.0327 10.2725 12.8758 10.1931Z"
              />
            </svg>
          </i>
          <i class="icon-file" @click="openFileChooser">
            <!-- <svg x="0px" y="0px" viewBox="0 0 20 20">
              <rect x="1.4" y="1.4" class="st0" width="17.1" height="17.1" />
              <g>
                <path
                  class="st1"
                  d="M10.9,7.1H9.1V10H6.6v1.9h2.6v2.9h1.7v-2.9h2.6V10h-2.6V7.1z"
                />
                <path
                  class="st1"
                  d="M16.9,3.3H9.5L8,1.7C8,1.6,7.9,1.5,7.8,1.5c-0.1,0-0.2-0.1-0.3-0.1H3.1c-0.9,0-1.7,0.9-1.7,1.9v13.3
      c0,1.1,0.8,1.9,1.7,1.9h13.7c0.9,0,1.7-0.9,1.7-1.9V5.2C18.6,4.2,17.8,3.3,16.9,3.3z M3.1,16.7V5.2h13.7l0,11.4H3.1z"
                />
              </g>
            </svg> -->
            <i class="el-icon-picture-outline"></i>
            <upload-image-message
              class="copyImg"
              :isShowCopy="true"
              @click="clickbanner"
              @sendEnter="sendEnter"
              ref="mychild"
            />
            <!-- <upload-image-message class="copyImg" :isShowCopy="false" /> -->
          </i>

          <i class="icon-comment" @click="commentHandler">
            <svg
              width="17"
              height="17"
              viewBox="0 0 18 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.4198 9.24108C18.5049 7.15612 18.5297 3.75068 16.4752 1.63476C16.457 1.61588 16.4385 1.59716 16.4199 1.57852C14.3789 -0.460516 11.126 -0.533076 8.99859 1.41292C6.8713 -0.533076 3.61829 -0.460516 1.57732 1.57852C-0.506212 3.665 -0.528443 7.07052 1.52758 9.18484C1.54406 9.2018 1.56061 9.2186 1.57732 9.23532L7.7945 15.4875C8.44786 16.1624 9.51651 16.172 10.1815 15.509L10.2026 15.4875L16.4198 9.24108ZM8.99865 13.862L15.0057 7.82684C16.3175 6.51505 16.3336 4.35993 15.0403 3.02801L15.0357 3.02322C15.0289 3.01616 15.0199 3.00698 15.0041 2.9911C13.7188 1.70949 11.685 1.66607 10.3485 2.88864L8.99856 4.12349L7.64865 2.88862C6.31172 1.66562 4.27686 1.70953 2.99175 2.99253C1.68166 4.30532 1.66747 6.45989 2.96142 7.79053C2.97128 7.80069 2.98187 7.81144 2.99186 7.82143L2.9955 7.82508L8.99865 13.862Z"
              />
            </svg>
          </i>

          <img
            src="@/assets/imgs/dingdan.svg"
            style="height:20px;margin-left:15px"
            v-if="urlData.enterScene != 5 && customerInfo.type != 2"
            @click.stop="showOrder"
            alt=""
          />
          <!-- <i
            v-show="customerInfo.type != 2"
            class="icon-comment el-icon-document"
          ></i> -->
        </div>
      </div>
      <textarea
        class="textarea addFocusEvent server-textarea"
        @click.right="showTextareaRightMenu"
        @keydown.13="send"
        @keydown.229="() => {}"
        maxlength="1024"
        @input="input"
        @paste="getClipboardFiles"
        ref="message-textarea"
        v-model.trim="message"
        placeholder="输入消息"
      ></textarea>
      <div class="send">
        <button
          @click="send"
          v-preventReClick
          :class="
            (message || this.messageImgs.length) && !isMsgUpload
              ? ''
              : 'disabled'
          "
          :disabled="
            (message || this.messageImgs.length) && !isMsgUpload ? false : true
          "
          class="btn"
          type="primary"
        >
          发送
        </button>
      </div>
      <CoolLightBox
        :slideshow="isshow"
        :items="uploadImages"
        :index="index"
        @close="closeImg"
      />
    </div>
    <orderList
      @dialogHide="dialogHide"
      :listStatus="listStatus"
      ref="orderList"
      v-if="listStatus"
      @checkOrder="checkOrder"
      :direction="direction"
    />
  </div>
</template>

<script>
import { Notification } from "element-ui";
import orderList from "src/app/customer/components/orderList";
import inputArea from "src/mixins/inputArea";
import utils from "../../utils";
import uploadImageMessage from "src/components/upload-image-message";
export default {
  name: "page-footer",
  mixins: [inputArea],
  components: {
    uploadImageMessage,
    orderList
  },
  data() {
    return {
      time: null,
      isTap: true,
      blob: {},
      isshow: false,
      images: [],
      index: null,
      uploadImages: [],
      direction: "rtl",
      sendEnterTimer: null,
      sendEnterFlag: false
    };
  },
  watch: {
    message(newVal) {
      if (this.isSend && !this.message) {
        this.sendEnter(
          this.$customerConstant.CUSTOMER_CONSTANT.CANCEL_ENTERING
        );
        return;
      }
      this.$store.commit("setState", {
        isSend: false
      });
      if (newVal) {
        this.sendEnter(this.$customerConstant.CUSTOMER_CONSTANT.ENTERING);
      }
    }
  },
  computed: {
    ...mapState({
      blackFlag: state => state.blackFlag,
      serverId: state => state.serverId,
      userId: state => state.userId,
      channelId: state => state.channelId,
      currCustomer: state => state.currCustomer,
      isMsgUpload: state => state.isMsgUpload,
      isSend: state => state.isSend,
      isEntering: state => state.isEntering,
      listStatus: state => state.listStatus,
      customerInfo: state => state.customerInfo,
      activeName: state => state.activeName,
      urlData: state => state.urlData
    })
  },
  methods: {
    checkOrder(item) {
      this.$store.commit("setState", { listStatus: false });
      utils.sendOrder(item);
    },
    dialogHide() {
      this.$store.commit("setState", { listStatus: false });
    },
    showOrder() {
      this.$store.commit("setState", { listStatus: true, activeName: "1" });
      // this.$refs.orderList.clearData();
      // this.$refs.orderList.getData();
    },
    input() {
      this.emotionVisible = false;
    },
    closeImg() {
      //关闭图片事件
      this.index = null;
      this.uploadImages = [];
    },
    commentHandler() {
      if (this.isTap) {
        this.isTap = false;
        clearTimeout(this.time);
        this.time = setTimeout(() => {
          this.isTap = true;
        }, 3000);
        if (this.blackFlag != 0) {
          Notification.warning({
            title: "提示：",
            message: "您暂时不能发起评价",
            position: "top-left"
          });
          return;
        }
        this.$store.commit("setState", {
          visibleEvaluate: true
        });
      }
    },
    sendEnter(num) {
      if (this.sendEnterFlag) {
        return;
      }
      this.sendEnterFlag = true;
      this.$service
        .serviceEntering({
          channelId: this.channelId,
          serverId: this.serverId,
          userId: this.userId,
          type: num
        })
        .then(res => {
          if ((res && res.code != 200) || !res) {
            clearTimeout(this.sendEnterTimer);
            this.sendEnterFlag = false;
          }
        })
        .catch(() => {
          clearTimeout(this.sendEnterTimer);
          this.sendEnterFlag = false;
        });
      let that = this;
      this.sendEnterTimer = setTimeout(() => {
        that.sendEnterFlag = false;
      }, 8000);
    },
    getClipboardFiles(e) {
      const html = e.clipboardData.getData("text/html");
      console.log(html);
      if (html.indexOf("excel") >= 0) {
        this.blob = "";
        return false;
      }
      let clipboardData = e.clipboardData,
        i = 0,
        items,
        item,
        types;
      if (clipboardData) {
        items = clipboardData.items;
        if (!items) {
          return;
        }

        item = items[0];
        types = clipboardData.types || [];
        for (; i < types.length; i++) {
          if (types[i] === "Files") {
            item = items[i];
            break;
          }
        }
        if (item.kind === "string") {
          let that = this;
          item.getAsString(function(str) {
            if (
              str.indexOf("amazonaws.com") > -1 &&
              (str.indexOf("png") > -1 ||
                str.indexOf("jpg") > -1 ||
                str.indexOf("jpeg") > -1)
            ) {
              that.message = "图片";
            }
            // str 是获取到的字符串
          });
        }
        if (item && item.kind === "file" && item.type.match(/^image\//i)) {
          const dom = document.getElementsByClassName("el-upload-list")[0]
            .children;
          if (!dom) {
            return;
          }
          if (
            (this.messageImgs && this.messageImgs.length > 4) ||
            dom.length > 4
          ) {
            this.$message.closeAll();
            this.$message.error(`图片数量超出限制，最多上传5张`);
            return;
          }

          this.blob = item.getAsFile();
          this.$refs.mychild.submits(this.blob);
          this.blob = "";
        }
      }
    },
    // 轮播
    clickbanner(e) {
      for (let i = 0; i < this.messageImgs.length; i++) {
        if (e.target.getAttribute("data") == this.messageImgs[i].url) {
          this.index = i;
        }
        var obj = {};
        obj["src"] = this.messageImgs[i].url;
        this.uploadImages.push(obj);
      }
      this.isshow = true;
    }
  },
  beforeDestroy() {
    clearTimeout(this.time);
    this.sendEnterFlag = false;
    clearTimeout(this.time);
  }
};
</script>
<style>
.toolbar .upload-wrap .upload-area .el-upload-list {
  z-index: 10;
}
</style>
<style lang="less" scoped>
.entering {
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  font-size: 12px;
  color: #787878;
  height: 25px;
  line-height: 25px;
  // padding: 0 5px 0 10px;
  width: 110px;
  z-index: 9;
  background: #ffffff;
  border-radius: 3px;
  padding-left: 5px;
}
.input-area {
  border-top: 1px solid #dedede;
  position: relative;
  height: 171px;
  .textarea {
    position: relative;
    display: block;
    width: 100%;
    padding: 8px 15px;
    resize: none;
    border: none;
    z-index: 12;
    outline: none;
    background-color: #fcfcfc;
    height: 90px;
  }

  .toolbar {
    display: flex;
    align-items: center;
    height: 30px;

    .wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;

      i:not(.el-icon-picture-outline) {
        display: inline-block;
        width: 17px;
        height: 17px;
        margin-left: 17px;
        background-size: 100% 100%;
        cursor: pointer;

        svg {
          fill: #7b7b7b;
        }

        &.active,
        &:active {
          svg {
            fill: var(--button-bg);
          }
        }

        &.icon-file {
          svg {
            .st0 {
              fill: none;
            }
          }
        }
      }

      i.el-icon-picture-outline {
        display: inline-block;
        font-size: 18.5px;
        color: #7b7b7b;
        font-weight: bold;

        &.active {
          color: var(--theme-bg);
        }
      }
    }
  }
}
.send {
  text-align: right;
  padding: 5px 10px;
  .btn {
    display: inline-block;
    width: 80px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 5px;
    background: var(--evaluate-solve-click) !important;
    color: #fff !important;
    border: none;
  }
  .disabled {
    opacity: 0.7;
    background: #999 !important;
  }
  .main .conversation .entering {
    bottom: 170px !important;
  }
}
</style>
